import IconArchive from './IconArchive';
import IconArrowDown from './IconArrowDown';
import IconArrowLeft from './IconArrowLeft';
import IconArrowRight from './IconArrowRight';
import IconArrowUp from './IconArrowUp';
import IconAsterisk from './IconAsterisk';
import IconBook from './IconBook';
import IconBullseye from './IconBullseye';
import IconCalendar from './IconCalendar';
import IconChartBar from './IconChartBar';
import IconCheck from './IconCheck';
import IconCheckCircle from './IconCheckCircle';
import IconChevronDown from './IconChevronDown';
import IconChevronLeft from './IconChevronLeft';
import IconChevronRight from './IconChevronRight';
import IconChevronUp from './IconChevronUp';
import IconClose from './IconClose';
import IconCode from './IconCode';
import IconCog from './IconCog';
import IconCuratr from './IconCuratr';
import IconEdit from './IconEdit';
import IconEllipsisV from './IconEllipsisV';
import IconExternalLink from './IconExternalLink';
import IconEye from './IconEye';
import IconFilter from './IconFilter';
import IconFlagCheckered from './IconFlagCheckered';
import IconGithub from './IconGithub';
import IconHome from './IconHome';
import IconInfoCircle from './IconInfoCircle';
import IconLink from './IconLink';
import IconNpm from './IconNpm';
import IconPen from './IconPen';
import IconPlus from './IconPlus';
import IconPlusCircle from './IconPlusCircle';
import IconProject from './IconProject';
import IconSearch from './IconSearch';
import IconStarHalf from './IconStarHalf';
import IconStarRegular from './IconStarRegular';
import IconStarSolid from './IconStarSolid';
import IconTachometer from './IconTachometer';
import IconThumbsDown from './IconThumbsDown';
import IconThumbsUp from './IconThumbsUp';
import IconTimes from './IconTimes';
import IconTimesCircle from './IconTimesCircle';
import IconTrash from './IconTrash';
import IconUsers from './IconUsers';

export {
  IconArchive,
  IconArrowDown,
  IconArrowLeft,
  IconArrowRight,
  IconArrowUp,
  IconAsterisk,
  IconBook,
  IconBullseye,
  IconCalendar,
  IconChartBar,
  IconCheck,
  IconCheckCircle,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconClose,
  IconCode,
  IconCog,
  IconCuratr,
  IconEdit,
  IconEllipsisV,
  IconExternalLink,
  IconEye,
  IconFilter,
  IconFlagCheckered,
  IconGithub,
  IconHome,
  IconInfoCircle,
  IconLink,
  IconNpm,
  IconPen,
  IconPlus,
  IconPlusCircle,
  IconProject,
  IconSearch,
  IconStarHalf,
  IconStarRegular,
  IconStarSolid,
  IconTachometer,
  IconThumbsDown,
  IconThumbsUp,
  IconTimes,
  IconTimesCircle,
  IconTrash,
  IconUsers,
};
